<template>
  <div class="achievement-analysis">
    <div class="tabs-list">
      <el-tabs v-model="tabSelectName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in filteredTabItems" :key="index" :name="item.name">
          <span slot="label">
            <el-tooltip :content="item.tooltip" placement="top">
              <span>{{ item.label }}</span>
            </el-tooltip>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <achievementAnalysisTopBar ref="topBar" @delScore="delScore" @viewDialogShowChange="viewDialogShowChange"
      @totalScoreDistributionSearch="totalScoreDistributionSearch" @copyStudentNames="copyStudentNames" @back="back"
      @courseRankSearch="courseRankSearch" @classRankSearch="classRankSearch" @gradeRankSearch="gradeRankSearch"
      @chartDialogShow="chartDialogClick" @selectCourseChange="selectCourseChange" @derivedScore="derivedScore"
      :tabSelectName="tabSelectName" :studentList="studentList" :courseList="courseList" :examInfo="examInfo"
      :classStatisticsData="classStatisticsData" :totalScoreDistributionList="totalScoreDistributionList"
      :courseScoreAnalysisList="courseScoreAnalysisList" :courseRankStudentList="courseRankStudentList"
      :classRankStudentList="classRankStudentList" :gradeRankStudentList="gradeRankStudentList"
      :standardGapList="standardGapList" :studentCourseSuperAverageList="studentCourseSuperAverageList"
      :classAverageScoreList="classAverageScoreList" />
    <div class="table">
      <!-- 学生排行 -->
      <studentRankTable v-show="tabSelectName === 'first'" @editStudentScore="editStudentScore"
        @studentSelect="studentSelect" :studentList="studentList" :examInfo="examInfo" :courseList="courseList"
        :courseFullList="courseFullList" />
      <!-- 各班成绩统计 -->
      <classPerformanceStatistics v-show="tabSelectName === 'second'" :classStatisticsData="classStatisticsData" />
      <!-- 总分分布 -->
      <totalScoreDistribution v-show="tabSelectName === 'third'"
        :totalScoreDistributionList="totalScoreDistributionList"
        :totalScoreDistributionShow="totalScoreDistributionShow" />
      <!-- 各科成绩分析 -->
      <subjectScoreAnalysis v-show="tabSelectName === 'fourth'" :courseScoreAnalysisList="courseScoreAnalysisList" />
      <!-- 单科排行 -->
      <courseRank v-show="tabSelectName === 'fifth'" :courseRankVal="courseRankVal"
        :courseRankStudentList="courseRankStudentList" />
      <!-- 各班排行 -->
      <classRank v-show="tabSelectName === 'sixth'" :classRankVal="classRankVal"
        :classRankStudentList="classRankStudentList" :classRankCourseList="classRankCourseList" />
      <!-- 年级排行 -->
      <gradeRank v-show="tabSelectName === 'seventh'" :gradeRankStudentList="gradeRankStudentList"
        :gradeRankCourseList="gradeRankCourseList" :gradeRankVal="gradeRankVal" />
      <!-- 平均分 -->
      <averageScore v-show="tabSelectName === 'eighth'" :classAverageScoreList="classAverageScoreList" />
      <!-- 超均率 -->
      <overAverage v-show="tabSelectName === 'ninth'" :studentCourseSuperAverageList="studentCourseSuperAverageList" />
      <!-- 标准差 -->
      <standardGap v-show="tabSelectName === 'tenth'" :standardGapList="standardGapList" />
    </div>
    <!-- 学生排行-分页容器 -->
    <div class="pagination-catainer" v-show="tabSelectName === 'first' || tabSelectName === 'seventh' && gradeRankVal">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
    </div>
    <!-- 学生排行-成绩对比 -->
    <barChartDialog :chartDialogShow.sync="chartDialogShow" :studentAvgScoreRankList="studentAvgScoreRankList"
      :courseFullList="courseFullList" v-show="chartDialogShow" />
    <!-- 学生排行-成绩修改 -->
    <scoreEditDialog :scoreInfo="scoreInfo" :scoreEditShow.sync="scoreEditShow" v-show="scoreEditShow"
      @scoreEditSubmit="scoreEditSubmit" />
    <!-- 查看视图弹窗 -->
    <viewDialog v-if="viewDialogShow" :courseScoreAnalysisDialogType="courseScoreAnalysisDialogType"
      :viewDialogData="viewDialogData" :tabSelectName="tabSelectName" :viewDialogShow.sync="viewDialogShow" />
  </div>
</template>

<script>
import achievementAnalysisTopBar from "./components/achievement-analysis-topBar/achievementAnalysisTopBar.vue";
import studentRankTable from "./components/student-rank-table/studentRankTable.vue";
import barChartDialog from "./components/bar-chart-dialog/barChartDialog.vue";
import scoreEditDialog from "./components/score-edit-dialog/scoreEditDialog.vue";
import pagination from "@/components/pagination/pagination";
import classPerformanceStatistics from "./components/class-performance-statistics/classPerformanceStatistics.vue";
import totalScoreDistribution from "./components/total-score-distribution/totalScoreDistribution.vue";
import subjectScoreAnalysis from "./components/subject-score-analysis/subjectScoreAnalysis.vue";
import gradeRank from "./components/grade-rank/gradeRank.vue";
import averageScore from "./components/average-score/averageScore.vue";
import overAverage from "./components/over-average/overAverage.vue";
import standardGap from "./components/standard-gap/standardGap.vue";
import courseRank from "./components/course-rank/courseRank.vue";
import classRank from "./components/class-rank/classRank.vue";
import viewDialog from "./components/view-dialog/viewDialog.vue";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  components: {
    achievementAnalysisTopBar,
    classPerformanceStatistics,
    studentRankTable,
    barChartDialog,
    pagination,
    scoreEditDialog,
    totalScoreDistribution,
    subjectScoreAnalysis,
    gradeRank,
    averageScore,
    overAverage,
    standardGap,
    courseRank,
    classRank,
    viewDialog
  },
  data() {
    return {
      viewDialogShow: false, // 查看视图弹窗
      viewDialogData: null,
      tabSelectName: null, // 选中的TAB
      tabItems: [
        { label: '学生排行', name: 'first', tooltip: '查看学生排行详情', permissionField: "sc:gradescore:rank", },
        { label: '各班成绩统计', name: 'second', tooltip: '查看各班成绩统计数据', permissionField: "sc:classscore:statistics", },
        { label: '总分分布', name: 'third', tooltip: '查看总分分布情况', permissionField: "sc:totalscore:distribution", },
        { label: '各科成绩分析', name: 'fourth', tooltip: '查看各科成绩分析', permissionField: "sc:course:analysis", },
        { label: '单科排名', name: 'fifth', tooltip: '查看单科排名', permissionField: "sc:singlesubject:ranking", },
        { label: '各班排名', name: 'sixth', tooltip: '查看各班排名情况', permissionField: "sc:class:ranking", },
        { label: '年级排名', name: 'seventh', tooltip: '查看年级排名', permissionField: "sc:grade:ranking", },
        { label: '平均分', name: 'eighth', tooltip: '查看平均分数据', permissionField: "sc:course:kpi", },
        { label: '超均率', name: 'ninth', tooltip: '查看超过平均分的比例', permissionField: "sc:course:kpi", },
        { label: '标准差', name: 'tenth', tooltip: '查看成绩的标准差', permissionField: "sc:course:kpi", }
      ],
      total: 0,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      classId: "",
      gradeId: "",
      examInfoId: "",
      examInfo: {},
      studentSelectList: [],
      studentList: [], // 学生排行列表
      studentAvgScoreRankList: [], // 学生单次考试学生成绩
      chartDialogShow: false,
      courseList: [],
      courseFullList: [], // 分制列表
      courseIds: [], // 选择指定的科目进行成绩排名的科目列表
      scoreEditShow: false, // 学生成绩修改弹窗
      scoreInfo: {}, // 学生成绩修改信息
      gradeRankVal: "", // 年级排名名次
      courseRankVal: "", // 单科排名名次
      classRankVal: "", // 班级排名名次
      classAverageScoreList: {}, // 平均分模块数据
      gradeExamSearchData: null, // 年级考试搜索条件
      gradeRankStudentList: [], // 年级排名名次学生列表
      gradeRankCourseList: [], // 年级排名科目列表
      classRankStudentList: [], // 班级排名名次学生列表
      classRankCourseList: [], // 班级排名科目列表
      courseRankStudentList: [], // 单科排名列表
      courseScoreAnalysisList: [], // 各科成绩分析列表
      courseScoreAnalysisDialogType: '', // 各科成绩分析弹窗类型
      totalScoreDistributionSearchData: {
        fractionalIntervalVal: "", // 总分分布-分数间隔
        cutoffScoreVal: "", // 总分分布-截止分数
      }, // 总分分布数据
      totalScoreDistributionShow: false, // 总分分布表格显示
      totalScoreDistributionList: [], // 总分分布列表
      standardGapList: [], // 标准差列表
      classStatisticsData: [], // 各班成绩统计列表
      studentCourseSuperAverageList: [], // 超均率列表
      menuPermissions: null // 存储从localStorage获取的权限
    };
  },
  created() {
    // 确保在组件创建时初始化权限检查
    this.hasPermission('');
    this.examInfo = JSON.parse(this.$route.query.examInfo);
    this.courseFullList = this.$route.query.courseFullList;
    if (this.$route.query.searchData) {
      // 年级考试搜索条件
      this.gradeExamSearchData = JSON.parse(this.$route.query.searchData);
    };
  },
  mounted() {
    this.refresh();
  },
  watch: {
    filteredTabItems: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.tabSelectName = newVal[0].name;
        } else {
          this.tabSelectName = null; // 或者设置为默认值或其他逻辑
        }
      },
      immediate: true // 立即触发一次handler
    }
  },
  computed: {
    filteredTabItems() {
      return this.tabItems.filter(item => this.hasPermission(item.permissionField));
    }
  },
  methods: {
    hasPermission(permissionField) {
      if (!this.menuPermissions) {
        // 如果menuPermissions为空，则从localStorage加载一次
        const permissions = window.localStorage.getItem("menuPermissions");
        this.menuPermissions = permissions ? permissions.split(',') : [];
      }
      return this.menuPermissions.includes(permissionField);
    },
    // 查看视图点击
    viewDialogShowChange(tagName) {
      this.viewDialogShow = true;
      if (tagName == 'third') {
        this.viewDialogData = this.totalScoreDistributionList;
      };
      if (tagName == 'fourth-score' || tagName == 'fourth-index') {
        this.courseScoreAnalysisDialogType = tagName; // 判断是分数视图还是指标视图
        this.viewDialogData = this.courseScoreAnalysisList;
      };
      if (tagName == 'sixth') {
        this.viewDialogData = this.classRankStudentList;
      };
      if (tagName == 'seventh') {
        this.viewDialogData = this.gradeRankStudentList;
      };
    },
    // 年级排名复制名字
    copyStudentNames() {
      if (this.gradeRankVal == '' || this.gradeRankStudentList.length == 0) return this.$message.warning('暂无学生列表');
      const names = this.gradeRankStudentList.map(student => student.studentName).join(', ');

      // 如果 navigator.clipboard 存在并且有 writeText 方法，则使用它
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(names).then(() => {
          this.$message.success('学生姓名已复制到剪贴板1');
        }).catch(err => {
          console.error('复制到剪贴板失败', err);
        });
      } else { // 否则使用备用方案
        const tempInput = document.createElement("input");
        tempInput.value = names;
        document.body.appendChild(tempInput);
        tempInput.select();
        try {
          document.execCommand('copy');
          this.$message.success('学生姓名已复制到剪贴板');
        } catch (err) {
          console.error('复制到剪贴板失败', err);
        } finally {
          document.body.removeChild(tempInput);
        }
      }
    },
    // 返回
    back() {
      this.$router.push({
        path: "/achievement-analysis-grade",
        query: {
          searchData: JSON.stringify(this.gradeExamSearchData)
        },
      });
    },
    // 平均分
    getClassAverageScoreList() {
      let data = {
        "gradeId": this.examInfo.gradeId,
        "examInfoId": this.examInfo.id
      };
      this.post(this.$url.selectStudentCourseRanking, data).then(res => {
        // console.log("getClassAverageScoreList:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.classAverageScoreList = res.data;
        // console.log(this.classAverageScoreList);

      });
    },
    // 单科排名搜索
    courseRankSearch(e) {
      this.courseRankVal = e;
      this.getPreCourseRank();
    },
    // 获取单科排名数据
    getPreCourseRank() {
      let data = {
        examInfoId: this.examInfo.id,
        rank: this.courseRankVal,
      };
      this.get(this.$url.selectPreCourseRank, data).then(res => {
        // console.log("selectPreCourseRank:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.courseRankStudentList = res.data;
      })
    },
    // 各班排名名次输入
    classRankSearch(e) {
      this.classRankVal = e;
      this.getPreClassRank();
    },
    // 获取各班排名数据
    getPreClassRank() {
      let data = {
        examInfoId: this.examInfo.id,
        rank: this.classRankVal,
      };
      this.get(this.$url.selectPreClassRank, data).then(res => {
        // console.log("selectPreClassRank:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.classRankStudentList = res.data;
        res.data.forEach(item => {
          item.scoreRankContrastDTOList.forEach(studentItem => {
            studentItem.courseInfoList.forEach(courseItem => {
              if (this.classRankCourseList.indexOf(courseItem.courseName) === -1) {
                this.classRankCourseList.push(courseItem.courseName);
              }
            })
          })
        })
      })
    },
    // 年级排名名次输入
    gradeRankSearch(e) {
      this.gradeRankVal = e;
      this.getPreGradeRank();
    },
    // 获取年级排名数据
    getPreGradeRank() {
      let data = {
        examInfoId: this.examInfo.id,
        rank: this.gradeRankVal,
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
      };
      this.get(this.$url.selectPreGradeRank, data).then(res => {
        // console.log("selectPreGradeRank:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.gradeRankStudentList = res.rows;
        this.total = res.total;
        res.rows.forEach(item => {
          item.courseInfoList.forEach(courseItem => {
            if (this.gradeRankCourseList.indexOf(courseItem.courseName) === -1) {
              this.gradeRankCourseList.push(courseItem.courseName);
            }
          })
        })
      })
    },
    // 总分分布搜索
    totalScoreDistributionSearch(data) {
      this.totalScoreDistributionSearchData = data;
      this.getTotalScoreComparison();
    },
    // 获取总分分数比较数据
    getTotalScoreComparison() {
      let data = {
        examInfoId: this.examInfo.id,
        intervalScore: this.totalScoreDistributionSearchData.fractionalIntervalVal,
        abortScore: this.totalScoreDistributionSearchData.cutoffScoreVal,
      };
      this.get(this.$url.selectTotalScoreComparison, data).then(res => {
        // console.log("selectAnalysisEachSubject:", res);
        if (res.code !== 200) {
          this.totalScoreDistributionShow = false;
          this.$message.error(res.msg);
          return;
        };
        this.totalScoreDistributionList = res.data;
        this.totalScoreDistributionShow = true;
      })
    },
    // 获取各科成绩分析数据
    getCourseScoreAnalysis() {
      let data = {
        examInfoId: this.examInfo.id,
      };
      this.get(this.$url.selectAnalysisEachSubject, data).then(res => {
        // console.log("selectAnalysisEachSubject:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.courseScoreAnalysisList = res.data;
      })
    },
    // 获取标准差排行数据
    getStandardGapList() {
      let data = {
        "examInfoId": this.examInfo.id
      };
      this.post(this.$url.selectStudentCourseRankingByStd, data).then(res => {
        // console.log("selectStudentCourseRankingByStd:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.standardGapList = res.data;
      });
    },
    // 各班成绩统计
    getClassPerformanceStatistics() {
      let data = {
        "examInfoId": this.examInfo.id
      };
      this.get(this.$url.selectEachClassStatistics, data).then(res => {
        // console.log("selectEachClassStatistics:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.classStatisticsData = res.data;
      });
    },
    // 超均率
    getStudentCourseSuperAverageList() {
      let data = {
        "examInfoId": this.examInfo.id
      };
      this.post(this.$url.selectStudentCourseSuperAverage, data).then(res => {
        // console.log("selectStudentCourseSuperAverage:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.studentCourseSuperAverageList = res.data;
      });
    },
    // tab切换
    handleClick(tab, event) {
      // console.log(tab, event, this.tabSelectName);
      this.refresh();
    },
    refresh() {
      this.gradeRankVal = "";
      this.courseRankVal = "";
      this.classRankVal = "";
      this.courseIds = [];
      this.$refs.topBar.selectCourseList = [];
      this.$refs.topBar.gradeRankVal = "";
      this.$refs.topBar.courseRankVal = "";
      this.$refs.topBar.classRankVal = "";
      this.totalScoreDistributionSearchData = {
        fractionalIntervalVal: "", // 总分分布-分数间隔
        cutoffScoreVal: "", // 总分分布-截止分数
      };
      this.$refs.topBar.totalScoreData = {
        fractionalIntervalVal: "", // 总分分布-分数间隔
        cutoffScoreVal: "", // 总分分布-截止分数
      };
      this.totalScoreDistributionList = [];
      this.totalScoreDistributionShow = false;
      if (this.tabSelectName === "first") {
        this.getStudentRanking();
      };
      if (this.tabSelectName === "second") {
        this.getClassPerformanceStatistics();
      };
      // if (this.tabSelectName === 'third') {
      //   this.getTotalScoreComparison();
      // }
      if (this.tabSelectName === 'fourth') {
        this.getCourseScoreAnalysis();
      };
      if (this.tabSelectName === "eighth") {
        this.getClassAverageScoreList();
      };
      if (this.tabSelectName === "ninth") {
        this.getStudentCourseSuperAverageList();
      };
      if (this.tabSelectName === "tenth") {
        this.getStandardGapList();
      };
    },
    // 修改学生成绩点击提交
    scoreEditSubmit(row) {
      let data = [];
      row.courseInfoList.map(item => {
        data.push({
          "examInfoId": this.examInfo.id,
          "studentId": row.studentId,
          "courseId": item.courseId,
          "score": item.score
        })
      })
      this.put(this.$url.updateScoreByStudent, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.scoreEditShow = false;
        this.getStudentRanking();
      })
    },
    // 修改学生成绩
    editStudentScore(row) {
      // console.log("row:", row);
      this.scoreEditShow = true;
      this.scoreInfo = row;
    },
    // 点击导出
    derivedScore() {
      let courseList = this.courseList.map((item) => item.courseId);
      // console.log(courseList);
      let action = `${baseURL}${this.$url.studentRankingExcelPC}?examInfoId=${this.examInfo.id
        }&gradeId=${this.examInfo.gradeId}&classId=${this.examInfo.classId || ""
        }&courseIds=${this.courseIds.length ? this.courseIds : courseList}`;
      window.open(action);

      // this.get(
      //   `${this.$url.studentRankingExcelPC}?examInfoId=${
      //     this.examInfo.id
      //   }&gradeId=${this.examInfo.gradeId}&classId=${
      //     this.examInfo.classId || ""
      //   }&courseIds=${this.courseIds.length ? this.courseIds : courseList}`
      // ).then((res) => {
      //   console.log("导出返回==>", res);
      //   window.location.href = baseURL + "/common/download?fileName=" + encodeURI(res.data) + "&delete=" + true;
      // });
    },
    // 选择指定的科目进行成绩排名
    selectCourseChange(e) {
      this.courseIds = e;
      this.getStudentRanking();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      if (this.tabSelectName === 'first') {
        this.getStudentRanking();
      } else if (this.tabSelectName === 'seventh') {
        this.getPreGradeRank();
      };
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      if (this.tabSelectName === 'first') {
        this.getStudentRanking();
      } else if (this.tabSelectName === 'seventh') {
        this.getPreGradeRank();
      };
    },
    // 获取学生排行
    getStudentRanking() {
      let data = {
        examInfoId: this.examInfo.id,
        gradeId: this.examInfo.gradeId,
        classId: this.examInfo.classId || "",
        studentName: "",
        studentNumber: "",
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
      };
      if (this.courseIds.length) {
        data.courseIds = this.courseIds;
      } else {
        delete data.courseIds;
      }
      this.post(this.$url.getStudentRanking, data).then((res) => {
        // console.log("获取学生排行：", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取学生排行失败");
        this.total = res.total;
        if (res.rows && res.total > 0) {
          res.rows.forEach((item) => {
            item.courseInfoList.forEach((aItem) => {
              if (
                !this.courseList.some(
                  (item) => item.courseName === aItem.courseName
                )
              ) {
                this.courseList.push({
                  courseName: aItem.courseName,
                  courseId: aItem.courseId,
                });
              }
            });
          });
        }

        this.studentList = res.rows;
      });
    },
    onceStudentAvgScoreRankContrast() {
      let data = {
        examInfoId: this.examInfo.id,
        studentIds: this.studentSelectList,
      };
      // console.log("data", data);
      this.post(this.$url.onceStudentAvgScoreRankContrast, data).then((res) => {
        if (res.code !== 200) return;
        // console.log("学生平均分排名对比：", res);
        this.chartDialogShow = true;
        this.studentAvgScoreRankList = res.data;
      });
    },
    chartDialogClick(e) {
      if (!this.studentSelectList.length)
        return this.$message.warning("请选择学生");
      if (this.studentSelectList.length < 2)
        return this.$message.warning("至少选择两个学生");
      this.onceStudentAvgScoreRankContrast();
    },
    // 学生排行-批量删除成绩
    delScore() {
      if (!this.studentSelectList.length) return this.$message.warning('请选择删除要删除的学生成绩');
      this.$confirm("此操作将永久删除该学生成绩, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            examInfoId: this.examInfo.id,
            studentIds: this.studentSelectList,
          };
          this.delete(this.$url.deleteStudentScore, data).then((res) => {
            if (res.code !== 200) return;
            this.$message.success("删除成功");
            this.getStudentRanking();
          });
        })
    },
    // 学生排行-选择学生-删除成绩用
    studentSelect(e) {
      this.studentSelectList = e;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementAnalysis.scss";
</style>